export interface PaymentMethodRadioOption {
  nickName: string;
  lastFourOrThree: string;
  id: string;
  icon: string;
  bankIcon: boolean;
  expireStatus: string;
}
